export const MOB_MAX_WIDTH = "600px";

export const COLOR_CURRENT = "#333333";
